module.exports = __webpack_public_path__ + "static/media/restWhite.e1a3df7d.svg";